<template>
  <b-modal
    visible
    scrollable
    :centered="UseUpClass ? false : true"
    no-close-on-backdrop    
    no-close-on-esc
    :title="TitleWindow"
    :id="ModalId"
    @show="Show"
    @shown="DoMovable"
    @hide="HideModal"
    :modal-class="UseUpClass ? 'UpModalClass is-draggable no-scroll-modal' :'is-draggable no-scroll-modal'"
   :dialog-class="dialogClass"
   >
  <slot></slot>

    <template #modal-footer>   
      <slot name="footer">      
        <template v-if="buttons.length">
          <b-button
            v-for="(btn, i) in buttons"
            :key="i"
            :variant="btn.variant || 'secondary'"
            :disabled="btn.disabled"
            @click="handleButton(btn,$event)"
          >
            {{ btn.text }}
          </b-button>
        </template>     
        <template v-else>
          <b-button variant="secondary" @click="Close">
            {{$t('Shared.Close')}}
          </b-button>
        </template>
      </slot>
    </template>

</b-modal>
</template>

<script>
export default {
  name: 'BaseModal',
  props:{
        UseUpClass:Boolean,
        ModalId:String,
        TitleWindow:String, 
        UseFuncShow:Boolean,
        FunctionShow:Function,      
        HideModalFun:Function,
        width: { type: String, default: null },  
        height: { type: String, default: null },  
        buttons: {type: Array,default: () => []},
        events: {type: Array,default: () => []},
        
  },

  data(){
    return{

    }
  },

computed: {
  dialogClass() {
    return {
      "custom-size-modal": true,
    };
  }
},

  methods:{
    HideModal(bvModalEvt){
      this.$emit("hide", bvModalEvt);
      this.HideModalFun();
    },

    Show(){
      if(this.UseFuncShow){
        this.FunctionShow();
      }      
    },

    Close(bvModalEvt){
      this.$emit("ok", bvModalEvt);
      this.$bvModal.hide(this.ModalId);
    },

     handleButton(btn,bvModalEvt) {    
      if (btn.action === "close") {        
        this.$emit("hide", bvModalEvt);
        //this.$bvModal.hide(this.ModalId);
      } else if (typeof btn.action === "function") {
        btn.action(bvModalEvt);
        this.$emit("ok", bvModalEvt);
      } else if (typeof btn.action === "string") {
        this.$emit("ok", bvModalEvt);
          this.$emit(btn.action);       
      }
    },

    DoMovable() {
      this.$nextTick(() => {
        const outer = document.getElementById(`${this.ModalId}___BV_modal_outer_`);
        const dialog = outer?.querySelector(".modal-dialog");
        const header = outer?.querySelector(".modal-header");
        if (!outer || !dialog || !header) return;   
        
        if (outer.classList.contains("is-draggable")) 
            return;

        header.style.cursor = "move";
        let dragging = false;
        let offsetX = 0;
        let offsetY = 0;

        header.onmousedown = (e) => {
          e.preventDefault();
          const rect = dialog.getBoundingClientRect();
          offsetX = e.clientX - rect.left;
          offsetY = e.clientY - rect.top;
          dragging = true;

          dialog.style.position = "fixed";
          dialog.style.margin = 0;
          dialog.style.transform = "none";
          dialog.style.left = `${rect.left}px`;
          dialog.style.top = `${rect.top}px`;
        };

        document.onmousemove = (e) => {
          if (!dragging) return;
          dialog.style.left = `${e.clientX - offsetX}px`;
          dialog.style.top = `${e.clientY - offsetY}px`;
        };

        document.onmouseup = () => {
          dragging = false;
        };
      });
      this.$emit("ShownModal"); 
    },
  },

  created(){

  },

  mounted(){
    const root = document.documentElement;
    root.style.setProperty("--modal-width", this.width || "40%");
    root.style.setProperty("--modal-height", this.height || "25%");

    if (window.innerWidth <= 600) {
      root.style.setProperty("--modal-width", "100%");
      root.style.setProperty("--modal-height", "100%");
    }
  }

   
};
</script>

<style>
.custom-size-modal {
  max-width: none !important;
  width: var(--modal-width) !important;
}

.custom-size-modal .modal-content {
  height: var(--modal-height) !important;
}

@media (max-width: 600px) {
  .modal {
    width: 100%;
    height: 100%;
  }
}

.UpModalClass{
  transform: translateY(10px);
}
.no-scroll-modal .modal-body {
  overflow: visible !important;
}

.no-scroll-modal .modal-dialog,
.no-scroll-modal .modal-content {
  overflow: visible !important;
}
</style>

